<div class="flex items-center box-border">
  <div [class]="checkboxDirectionStyles[direction()]" class="gap-3">
    <input
      type="checkbox"
      [id]="id()"
      [checked]="value"
      [disabled]="isDisabled"
      (change)="onValueChange($event)"
      class="appearance-none w-3 h-3 ring-2 ring-offset-2 ring-primary-700 rounded-xs bg-white checked:bg-primary-700 cursor-pointer box-border" />
    <label [for]="id()" class="text-sm font-light text-text">{{
      label()
    }}</label>
  </div>
</div>
